import React, { useState } from 'react';
import { 
  Package, 
  MessageSquare, 
  Users, 
  ShoppingCart, 
  ListTree, 
  BadgeEuro, 
  StickyNote, 
  Menu, 
  Cog,
  ChevronDown,
  ChevronRight,
  Truck,
  MapPin,
  TicketPercent,
  LogOut,
  PackageOpen,
  QrCode,
  Puzzle,
  Dot,
  ClipboardPenLine
} from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const navigate = useNavigate();

  const navigation = [
    // Content Management
    {
      group: 'Contenu',
      items: [
        { name: 'Pages', icon: StickyNote, path: '/pages' },
        { name: 'Navigation', icon: Menu, path: '/navigation-editor' },
      ]
    },
    // Product Management
    {
      group: 'Catalogue',
      items: [
        // { name: 'Produits', icon: Package, path: '/products' },
        // { name: 'Catégories', icon: ListTree, path: '/categories' },
        {
          name: 'Matériel',
          icon: Package,
          submenu: [
            { name: 'Produits', icon: Package, path: '/products' },
            { name: 'Catégories', icon: ListTree , path: '/categories' },
          ]
        },
        {
          name: 'Vente',
          icon: Package,
          submenu: [
            { name: 'Produits en Vente', path: '/product-sales' },
            { name: 'Catégories', path: '/sale-categories' },
          ]
        },
        {
          name: 'Loisirs',
          icon: Puzzle,
          submenu: [
            { name: 'Produits loisirs', path: '/loisir-products' },
            { name: 'Formules', path: '/formulas' },
          ]
        },
        {
          name: 'Ateliers',
          icon: ClipboardPenLine,
          submenu: [
            { name: 'Les ateliers', path: '/workshops' },
            { name: 'Catégories', path: '/workshop-categories' },
            { name: 'Réservations', path: '/workshop-reservations' },
            { name: 'Page d\'accueil', path: '/workshop-page' },
          ]
        },
      ]
    },
    // Sales & Orders
    {
      group: 'Ventes',
      items: [
        { name: 'Commandes', icon: ShoppingCart, path: '/orders' },
        { name: 'Transactions', icon: BadgeEuro, path: '/transactions' },
        { name: 'Coupons', icon: TicketPercent, path: '/coupons' },
        { name: 'Pré-commandes', icon: PackageOpen, path: '/pre-orders' },
      ]
    },
    // Delivery Management
    {
      group: 'Livraisons',
      items: [
        {
          name: 'Livraisons',
          icon: Truck,
          submenu: [
            { name: 'Zones de livraison', path: '/delivery-zones' },
            { name: 'Points relais', path: '/pickup-points' },
          ]
        },
      ]
    },
    // Customer Service
    {
      group: 'Service Client',
      items: [
        { name: 'Messages', icon: MessageSquare, path: '/messages' },
        { name: 'Utilisateurs', icon: Users, path: '/users' },
      ]
    },
    // Settings
    {
      group: 'Configuration',
      items: [
        { name: 'Informations entreprise', icon: Cog, path: '/company-info' },
        { name: 'Paramètres généraux', icon: Cog, path: '/general-settings' },
        { name: 'QR Code', icon: QrCode, path: '/qr-generator' },
      ]
    },
  ];

  const toggleSubmenu = (menuName) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const renderMenuItem = (item) => {
    if (item.submenu) {
      return (
        <div key={item.name} className="mb-2">
          <button
            onClick={() => toggleSubmenu(item.name)}
            className="btn btn-light text-start w-100 d-flex align-items-center justify-content-between"
          >
            <span className="d-flex align-items-center">
              <item.icon className="me-2" size={20} />
              {item.name}
            </span>
            {expandedMenus[item.name] ? (
              <ChevronDown size={16} />
            ) : (
              <ChevronRight size={16} />
            )}
          </button>
          {expandedMenus[item.name] && (
            <div className="ms-4 mt-2">
              {item.submenu.map((subItem) => (
                <Link
                  key={subItem.path}
                  to={subItem.path}
                  className={`btn text-start mb-2 d-flex align-items-center ${
                    location.pathname === subItem.path ? 'btn-primary' : 'btn-light'
                  }`}
                >
                  {subItem.icon ? (
                    <subItem.icon className="me-2" size={16} />
                  ):(
                    <Dot className="me-2" size={16} />
                  )}
                  {subItem.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      );
    }

    return (
      <Link
        key={item.path}
        to={item.path}
        className={`btn text-start mb-2 d-flex align-items-center ${
          location.pathname === item.path ? 'btn-primary' : 'btn-light'
        }`}
      >
        <item.icon className="me-2" size={20} />
        {item.name}
      </Link>
    );
  };

  const handleLogout = () => {
    localStorage.setItem('isAuthenticated', 'false');
    navigate('/login');
    return;
  }

  return (
    <nav className="bg-white shadow-sm min-vh-100" style={{ width: '250px' }}>
      <div className="d-flex flex-column p-3">
        {navigation.map((section, index) => (
          <div key={section.group} className="mb-3">
            <div className="text-muted small text-uppercase mb-2 ms-2">
              {section.group}
            </div>
            {section.items.map(renderMenuItem)}
            {index < navigation.length - 1 && (
              <hr className="my-3" />
            )}
          </div>
        ))}
        <hr className="my-3" />
        <button
          onClick={handleLogout}
          className="btn text-start mb-2 d-flex align-items-center btn-outline-danger"
        >
          <LogOut className="me-2" size={20} />
          Déconnexion
        </button>
      </div>
    </nav>
  );
};

export default Sidebar;